import React, { Component } from 'react';

class TextArea extends Component {
  render () {
    const { id, classNames, title, hascontainer, ...others } = this.props;
    let classes = classNames;
    if (!classNames) classes = '';

    let jsx = <textarea {...others} id={id} name={id} className={`${classes} form-control md-textarea`}></textarea>

    if (hascontainer) {
      jsx = (
        <div class="md-form">
					<label for={id}>{title}</label>
					<textarea {...others} id={id} name={id} className={`${classes} form-control md-textarea`}></textarea>
				</div>
      );
    }

    return jsx;
  }
};

export default TextArea;
